"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function withPostFetch(behavior) {
  return {
    postBehavior: behavior
  };
}

exports.default = withPostFetch;